import styled from 'styled-components/macro';
import vw from 'rpf/un/vw';
import LongPage from 'rpf/react/components/LongPage';
import ScrollWrap from 'components/ScrollWrap';
import autobg from 'autobg.macro';

export const Wrap = styled(LongPage)`
  position: relative;
  background-color: #fcf6e6;
`;

export const Bg = styled.div`
  ${autobg('assets/img/home/bg.png')}
`;

export const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: ${vw(6019)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TimeBlock = styled.div`
  ${autobg('assets/img/home/block_time.png')}
  margin-top: ${vw(801)};
`;

export const InfoBlock = styled.div`
  position: relative;
  ${autobg('assets/img/home/block_info.png')}
  margin: ${vw(46)} auto 0 0;
`;

export const GetBtn = styled.div`
  ${autobg('assets/img/home/btn_get.png')}
  position: absolute;
  left: ${vw(188)};
  top: ${vw(1592)};
`;

export const BannerWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${vw(47)};
`;

const banner = {
  master: autobg('assets/img/home/banner_master.png'),
  visa: autobg('assets/img/home/banner_visa.png')
};
export const Banner = styled.div`
  ${p => banner[p.type]}
`;

export const SignBtn = styled.div`
  ${autobg('assets/img/home/btn_sign.png')}
  margin-top: ${vw(44)};
`;

export const FeatureBlock = styled.div`
  ${autobg('assets/img/home/block_feature.png')}
  position: relative;
  margin-top: ${vw(41)};
`;

const card = {
  master: {
    img: autobg('assets/img/home/card_master.png'),
    left: vw(16),
    btn: autobg('assets/img/home/btn_master.png'),
    btnLeft: vw(28)
  },
  visa: {
    img: autobg('assets/img/home/card_visa.png'),
    left: vw(359),
    btn: autobg('assets/img/home/btn_visa.png'),
    btnLeft: vw(406)
  }
};
export const Card = styled.div`
  ${p => card[p.type].img}
  position: absolute;
  top: ${vw(499)};
  left: ${p => card[p.type].left};
`;

export const ListBtn = styled.div`
  ${p => card[p.type].btn}
  position: absolute;
  top: ${vw(912)};
  left: ${p => card[p.type].btnLeft};
`;

export const InquireBlock = styled.div`
  ${autobg('assets/img/home/block_inquire.png')}
  position: relative;
  margin-top: ${vw(57)};
`;

export const AreaTitile = styled.div`
  margin: ${vw(41)} 0 ${vw(28)} ${vw(20)};
  font-size: ${vw(30)};
  font-weight: bold;
  color: #2c2d40;
`;

export const AreaText = styled.div`
  margin-bottom: ${vw(16)};
  padding: 0 ${vw(20)};
  font-size: ${vw(28)};
  color: #606179;
  line-height: 1.4;
`;

export const RuleBlock = styled.div`
  ${autobg('assets/img/home/block_rule.png')}
  margin-top: ${vw(57)};
  padding-bottom: ${vw(43)};
`;

export const RuleContent = styled(ScrollWrap).attrs({
  width: 660,
  height: 300
})`
  margin: ${vw(120)} auto 0;
  padding-right: ${vw(10)};
  font-size: ${vw(28)};
  color: #606179;
  div {
    margin-bottom: ${vw(10)};
    text-indent: 1.5em;
    line-height: 1.2;
  }
`;

const item = [
  {
    img: autobg('assets/img/home/item_1.png'),
    left: 658,
    top: 1310
  },
  {
    img: autobg('assets/img/home/item_2.png'),
    left: 0,
    top: 2615
  },
  {
    img: autobg('assets/img/home/item_3.png'),
    left: 608,
    top: 3675
  },
  {
    img: autobg('assets/img/home/item_4.png'),
    left: 15,
    top: 5450
  }
];
export const Item = styled.div`
  ${p => item[p.type].img}
  position:absolute;
  left: ${p => vw(item[p.type].left)};
  top: ${p => vw(item[p.type].top)};
  pointer-events: none;
`;
